import { defaultDictionary, TranslationKeys } from '@/translations';

export function isTranslationKey(key: string): key is TranslationKeys {
    return key in defaultDictionary;
}
